import styled from 'styled-components'

export const Header = styled.div`
	display: flex;
	justify-content: space-between;
	padding: 0 0 24px;
`
